export default __webpack_public_path__ + "static/SMS-0f579801f468b33d774620c538495eaf.svg";